
































import { Vue, Component, Prop } from 'vue-property-decorator';

import { Surface, Typography } from '@/components/atoms';
import DateUtils from '@/utils/DateUtils';

import SocialMediaIcon from '@/components/icons/SocialMedia.vue';
import PercentageCircleIcon from '@/components/icons/PercentageCircle.vue';
import CalendarIcon from '@/components/icons/Calendar.vue';

import { TDeadLineType } from '@/models/marketingCenter/freeCoins';

@Component({
  components: {
    Surface,
    Typography,
    SocialMediaIcon,
    PercentageCircleIcon,
    CalendarIcon
  }
})
export default class CampaignSettingsPreview extends Vue {
  @Prop() campaignName?: string;
  @Prop() bonusPercentage?: string;
  @Prop() expiration?: string;
  @Prop() expirationType?: TDeadLineType;

  get tPrefix() {
    return 'sellCoins.campaign.sideBar';
  }

  get bonusPercentageText() {
    return this.bonusPercentage === 'Other' || this.bonusPercentage === '%'
      ? '--'
      : this.bonusPercentage;
  }

  get expirationLabel() {
    if (this.expiration && this.expirationType !== 'no-deadline') {
      const [date] = this.expiration.split('T');

      return DateUtils.formattedDate({ date });
    }

    return 'No expiration date';
  }
}
